import { jsx } from '@amazon/vinyl-tsx'
import {
    BrowseMusicCollections,
    type BrowseMusicCollectionsDeps,
} from '@/browse/BrowseMusicCollections'

export type PodcastsDeps = BrowseMusicCollectionsDeps

export interface PodcastsProps {
    readonly deps: PodcastsDeps
}

/**
 * Podcasts home — mirrors green hornet's `PodcastsHome` page. Uses the
 * `podcast-home` recommendation collection (the equivalent of `music-home`
 * for the music tab) to render a flowing grid of podcast shovelers.
 */
export function Podcasts(props: PodcastsProps) {
    return (
        <div className="podcastsHome browseHome">
            <BrowseMusicCollections data={{ type: 'podcast-home' }} deps={props.deps} />
        </div>
    )
}
